import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable , of, throwError } from 'rxjs';
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { OnboardingRequest} from '../model/models';
import {NGXLogger} from "ngx-logger";
import {ReferenceCode} from "../../process/models/referenceCode";

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  private onboardingResponse!: OnboardingSuccessfulResponse;
  private onboardingExceptionResponse!: OnboardingExceptionResponse;

  /**
   * Constructor
   * @param httpClient Http client instance.
   * @param logger Logger instance.
   */
  constructor(private httpClient: HttpClient,
              private logger: NGXLogger) { }

  /**
   * Mock onboarding request
   */
  processOnboarding(accountType: string, accountNumber: string, firstName: string, userName: string, isExistingCustomer: boolean): Observable<OnboardingSuccessfulResponse> {
    const response: OnboardingSuccessfulResponse = {
      accountType: accountType,
      accountNumber: accountNumber,
      username: userName,
      firstName: firstName,
      isEnrolledOLB: isExistingCustomer
    };

    this.onboardingResponse = response;
    return of(this.onboardingResponse);
  }

  processOnboardingError(code: ReferenceCode): Observable<OnboardingExceptionResponse> {
    const exceptionResponse: OnboardingExceptionResponse = {
      refCode: code
    }
    this.onboardingExceptionResponse = exceptionResponse;
    return of(this.onboardingExceptionResponse);
  }

  processOnboardingUnderReview(code: ReferenceCode): Observable<OnboardingExceptionResponse> {
    const exceptionResponse: OnboardingExceptionResponse = {
      refCode: code
    }
    this.onboardingExceptionResponse = exceptionResponse;
    return of(this.onboardingExceptionResponse);
  }

  getNewAccountInformation(): OnboardingSuccessfulResponse {
    return this.onboardingResponse;
  }

  setUsername(username: string){
    this.onboardingResponse.username = username;
  }

  setOlbAccountCreationSuccessfull(): void {
    this.onboardingResponse.olbCredentialCreationSuccessfull = true;
  }

  getAccountCreationError(): OnboardingExceptionResponse {
    return this.onboardingExceptionResponse;
  }

  /**
   * Handle error is called if there is an error processing the request.
   * @param error Error from service.
   * @param methodName Method that generated the error
   * @protected
   */
  protected handleError(error: any, methodName: string = '') {
    const message = error?.detail || 'An error occurred, please contact support.';
    return throwError(message);
  }
}

// Mock response interface, will be replaced by corresponding client object
// once the real onboarding call is implemented
export interface OnboardingSuccessfulResponse {
  accountType: string;
  accountNumber: string;
  username: string;
  firstName: string;
  isEnrolledOLB: boolean;
  olbCredentialCreationSuccessfull?: boolean;
}

export interface OnboardingExceptionResponse {
  refCode: ReferenceCode;
}
